module.exports = __webpack_public_path__ + "img/cross.5383ac0a.svg";